<template>
  <div :class="{ standalone: 'standalone' }">
    <ContentSection skew="right" id="our-people" class="z-0 bg-tawnyorange-500 pb-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white">Case studies</h1>
          <p class="text-white text-2xl font-light">
            Browse some examples to see how we've applied our expertise to deliver solutions for
            businesses like yours.
          </p>
        </div>
      </div>
    </ContentSection>
    <ContentSection id="case-stidies-index" skew="right" class="z-0 bg-grey-100 my-0 pt-16 pb-48">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-12">
          <div class="flex-2col">
            <div
              class="card-wrap  pb-3 sm:pr-3"
              v-for="item in Store.caseStudies"
              v-bind:key="item.slug"
            >
              <div class="card card_caseStudy shadow">
                <router-link
                  :to="{ name: 'case-study', params: { case: item.slug } }"
                  class="w-full flex content-start"
                  :class="{
                    blue: item.color === 'blue',
                    darkblue: item.color === 'darkblue',
                    red: item.color === 'red',
                    orange: item.color === 'orange',
                    green: item.color === 'green',
                    purple: item.color === 'purple',
                    brown: item.color === 'brown'
                  }"
                >
                  <div class="number text-5xl font-black flex-0 px-1 -m-3 p-3 px-5 text-white">
                    {{ padd(item.id + 1) }}
                  </div>
                  <div
                    class="title flex-1 text-xl pt-2 pr-2 pl-8 leading-snug"
                    v-html="item.title"
                  ></div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'CaseStudiesIndex',
  props: ['standalone'],
  components: {
    ContentSection
  },
  data: function() {
    return {
      isStandalone: this.standalone
    };
  },
  methods: {
    // routeTo: function(slug) {
    //   this.$router.push({ path: `/case-studies/${slug}` });
    // },
    padd: function(num) {
      if (num < 10) {
        return '0' + num;
      } else {
        return num;
      }
    }
  }
};
</script>

<style lang="scss">
@mixin caseStudyTheme($primary) {
  .case {
    .no {
      color: rgba($primary, 0.3);
    }
    .name a,
    .name span {
      color: $primary;
    }
    &:hover {
      background: darken($primary, 10%);
      .no,
      .name a,
      .name span {
        color: #fff;
      }
    }
  }
}

.standalone {
  margin-bottom: -130px;
}

.sect--work {
  margin: 0 0 -50px 0;
  padding: 50px 0 150px 0;
  background: $Grey1WhiteSmoke;
  transform: skewY($skew);
  > .inner {
    transform: skewY($-skew);
  }
  &.standalone {
    margin-top: 70px;
    padding-top: 10px;
    margin-bottom: 80px;
    padding-bottom: 100px;
    .inner {
      // margin-top: 20px;
    }
  }
}

.work-grid {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: center;
  margin: 20px 0 0 0;
  a.item,
  div.item {
    width: 100%;
    cursor: pointer !important;
    @include media('>500px') {
      width: 50%;
    }

    .case {
      @include rtp_transition($property: 'transform', $duration: 0.3s);
      position: relative;
      margin: 3px;
      height: 110px;
      background: #fff;
      border-radius: 2px;
      cursor: pointer !important;
      @include media('>=450px') {
        height: 125px;
      }
      &:hover {
        background: darken($CaseStudyBlue, 10%);
        box-shadow: 0px 2px 7px 0 rgba(102, 102, 102, 0.2);
        .no,
        .name a,
        .name span {
          color: #fff;
        }
        .name a,
        .name span {
          text-decoration: underline;
        }
      }

      .no {
        font-family: $brand-font-family;
        font-size: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
        font-weight: 800;
        z-index: 10;
        color: rgba($CaseStudyBlue, 0.3);
        padding: 0 0 0 15px;
        @include media('>=medium') {
          // top: 0px;
          // left: 0px;
          padding: 5px 0 0 25px;
        }
      }
      .name {
        @include rtp_transition($duration: 0.55s);
        position: absolute;
        z-index: 15;
        top: auto;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0px 10px 10px 15px;
        color: $CaseStudyBlue;
        // color: #fff !important;
        cursor: pointer;
        @include media('>=medium') {
          // top: 55px;
          padding: 10px 25px 15px 25px;
        }
        a,
        span {
          color: $CaseStudyBlue;
          font-family: $brand-font-family;
          // color: #fff !important;
          font-size: 19px;
          font-weight: 400;
          line-height: 1.2em;
          text-decoration: none;
          @include media('>500px') {
            font-size: 17px;
          }
          @include media('>=medium') {
            // font-size: 17px;
          }
          @include media('>800px') {
            font-size: 19px;
          }
          // &:hover {
          //   color: #fff;
          //   text-decoration: underline;
          // }
        }
      }
    }
    &.blue {
      @include caseStudyTheme($CaseStudyBlue);
    }
    &.darkblue {
      @include caseStudyTheme($CaseStudyDarkBlue);
    }
    &.red {
      @include caseStudyTheme($CaseStudyRed);
    }
    &.orange {
      @include caseStudyTheme($CaseStudyOrange);
    }
    &.green {
      @include caseStudyTheme($CaseStudyGreen);
    }
    &.purple {
      @include caseStudyTheme($CaseStudyPurple);
    }
    &.brown {
      @include caseStudyTheme($CaseStudyBrown);
    }
  }
}
</style>
